var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"home,smoke,wine,release,export"}},[_c('router-view')],1),_c('img',{staticClass:"logo_code code1",attrs:{"src":require("./assets/img/code1.png"),"alt":""}}),_c('img',{staticClass:"logo_code code2",attrs:{"src":require("./assets/img/code2.png"),"alt":""}}),_c('el-backtop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }